// TSS vite/02 — centralized constants.
// Service lines from the brand manual (§5). Read by the landing sections,
// the contact form selector and the footer, so they live here.

export const SERVICES = [
    {
        id: 'asesoria',
        title: 'Acompañamiento y asesoría estratégica',
        shortTitle: 'Asesoría estratégica',
        summary: 'Te ayudamos a tomar mejores decisiones sobre tus canales, tu audiencia y tu modelo de negocio.',
        items: ['Diagnóstico de canales', 'Modelos de monetización', 'Planeación de contenidos', 'Hoja de ruta de crecimiento'],
        image: 'service-strategy',
        imageAlt: 'Equipo planeando una estrategia con notas adhesivas en una pared',
    },
    {
        id: 'marketing',
        title: 'Marketing y posicionamiento',
        shortTitle: 'Marketing digital',
        summary: 'Hacemos crecer tu audiencia y tus ingresos con campañas medibles y comunidades activas.',
        items: ['Growth digital', 'Pauta publicitaria', 'Email marketing', 'Gestión de comunidades'],
        image: 'service-marketing',
        imageAlt: 'Tablero de analítica digital con gráficas de audiencia',
    },
    {
        id: 'audiovisual',
        title: 'Producción audiovisual',
        shortTitle: 'Producción audiovisual',
        summary: 'Contamos tus historias con piezas de alto impacto, desde la idea hasta la postproducción.',
        items: ['Coberturas', 'Spots comerciales', 'Podcasting', 'Edición y postproducción'],
        image: 'service-audiovisual',
        imageAlt: 'Línea de tiempo de edición de video en una pantalla',
    },
    {
        id: 'web',
        title: 'Desarrollo web y plataformas',
        shortTitle: 'Desarrollo web',
        summary: 'Construimos plataformas rápidas, seguras y listas para crecer con tu medio.',
        items: ['Portales de noticias', 'Sitios corporativos de alta velocidad', 'Streaming', 'Landing pages de captación'],
        image: 'service-web',
        imageAlt: 'Pantallas con diseños de sitios web en desarrollo',
    },
];

export const SERVICE_IDS = SERVICES.map(service => service.id);
